import { PurchaseOrderDto } from './purchaseOrder.dto';
import { BaseDto } from './base.dto';

export class PurchaseOrderCreditNoteStatusDto extends BaseDto {
    purchaseOrderCreditNoteStatus: string;
    purchaseOrderCreditNote: PurchaseOrderDto[];
}